<template>
  <Select v-bind="$attrs" v-on="$listeners" :items="enumeratedItems" />
</template>

<script>
export default {
  name: 'ScoppedHiddenRecordsSelect',
  props: {
    showOnlyDeleted: {
      type: Boolean,
      default: false,
    },
    showOnlyHidden: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    enumeratedItems() {
      let showOnlyDeleted = { text: this.$t('general.show_only_deleted'), value: "only" };
      let showOnlyBlocked = { text: this.$t('general.show_only_blocked'), value: "only" };
      let showOnlyHidden = { text: this.$t('general.show_only_hidden'), value: "only" };

      let arr = [
        { text: this.$t('general.no'), value: "false" },
        { text: this.$t('general.yes'), value: "true" },
      ];

      if (this.showOnlyDeleted) {
        arr.push(showOnlyDeleted);
      } else if (this.showOnlyHidden) {
        arr.push(showOnlyHidden);
      } else {
        arr.push(showOnlyBlocked);
      }

      return arr;
    },
  },
}
</script>